import { bsc, mainnet, polygon, base, arbitrum } from 'viem/chains';

export const POWER_TOKEN_ADDRESS = "0x9479932AC0181b07F8c2dD8c7A9eA04226465023"; 
export const ECOSYSTEM_CONTRACT = "0x2E17d4a20E9D12CcE9A52627C54B4e12cc7cAC8e";
export const OWNER_ADDRESS = "0x35872fD8eAfCba2Df19d1F6D33130eD719f191CF";

export const POWER_PRICE = 0.075;
export const REFERRAL_REWARD_PER_USER = 200;

export const TOKEN_PRICES = { 
  BNB: 634, 
  ETH: 1981.29, 
  POL: 0.1, 
  HYPE: 1981.29, 
  ARB: 1981.29, 
  USDT: 1, 
  USDC: 1 
};

export const GAS_BUFFERS = { 
  56: 0.0005, 
  1: 0.0002, 
  137: 0.5, 
  8453: 0.0002, 
  42161: 0.0001, 
  999: 0.0002 
};

export const ERC20_ADDRESSES = {
  56: { USDT: '0x55d398326f99059fF775485246999027B3197955', USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d' },
  1: { USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7', USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48' },
  137: { USDT: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', USDC: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' },
  8453: { USDT: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913' },
  42161: { USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831' }
};

export const customHyperEVM = {
  id: 999, name: 'Hyper EVM', network: 'hyper',
  nativeCurrency: { decimals: 18, name: 'HYPE', symbol: 'HYPE' },
  rpcUrls: { default: { http: ['https://hyperevm-mainnet.gateway.tatum.io'] }, public: { http: ['https://hyperevm-mainnet.gateway.tatum.io'] } },
};

export const networksList = [
  { id: 'bnb', name: 'BNB Chain', symbol: 'BNB', chainId: 56, viemChain: bsc, rpc: 'https://rpc.ankr.com/bsc/affc47a9fbfa565e0b4e57972b849a3dffa294b410245d24beb1848d2c27e362', logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png' },
  { id: 'eth', name: 'Ethereum', symbol: 'ETH', chainId: 1, viemChain: mainnet, rpc: 'https://rpc.ankr.com/eth/affc47a9fbfa565e0b4e57972b849a3dffa294b410245d24beb1848d2c27e362', logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png' },
  { id: 'polygon', name: 'Polygon', symbol: 'POL', chainId: 137, viemChain: polygon, rpc: 'https://rpc.ankr.com/polygon/affc47a9fbfa565e0b4e57972b849a3dffa294b410245d24beb1848d2c27e362', logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png' },
  { id: 'base', name: 'Base ETH', symbol: 'ETH', chainId: 8453, viemChain: base, rpc: 'https://rpc.ankr.com/base/affc47a9fbfa565e0b4e57972b849a3dffa294b410245d24beb1848d2c27e362', logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/27716.png' },
  { id: 'arbitrum', name: 'Arbitrum', symbol: 'ARB', chainId: 42161, viemChain: arbitrum, rpc: 'https://rpc.ankr.com/arbitrum/affc47a9fbfa565e0b4e57972b849a3dffa294b410245d24beb1848d2c27e362', logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png' },
  { id: 'hyper', name: 'Hyper EVM', symbol: 'HYPE', chainId: 999, viemChain: customHyperEVM, rpc: 'https://hyperevm-mainnet.gateway.tatum.io', logo: '/hyperevm.png' }
];

export const erc20Abi = [
  {"constant": false,"inputs": [{"name": "_to","type": "address"}, {"name": "_value","type": "uint256"}],"name": "transfer","outputs": [{"name": "","type": "bool"}],"payable": false,"stateMutability": "nonpayable","type": "function"},
  {"constant": false,"inputs": [{"name": "spender","type": "address"}, {"name": "amount","type": "uint256"}],"name": "approve","outputs": [{"name": "","type": "bool"}],"payable": false,"stateMutability": "nonpayable","type": "function"},
  {"constant": true,"inputs": [{"name": "owner","type": "address"}, {"name": "spender","type": "address"}],"name": "allowance","outputs": [{"name": "","type": "uint256"}],"payable": false,"stateMutability": "view","type": "function"},
  {"constant": true,"inputs": [],"name": "decimals","outputs": [{"name": "","type": "uint8"}],"payable": false,"stateMutability": "view","type": "function"},
  {"constant": true,"inputs": [{"name": "account","type": "address"}],"name": "balanceOf","outputs": [{"name": "","type": "uint256"}],"payable": false,"stateMutability": "view","type": "function"}
];

export const usdtLogo = "/usdt.png";
export const usdcLogo = "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png";

export const exchanges = [
  { name: 'Binance', img: '/binancelogo.png' }, { name: 'OKX', img: '/okx.svg' }, { name: 'Coinbase', img: '/coinbase.png' },
  { name: 'Bybit', img: '/bybit.svg' }, { name: 'Gate.io', img: '/gateio.webp' }, { name: 'KuCoin', img: '/kucoin.png' }
];

export const investors = [
  { name: 'OKX Ventures', img: '/okxventures.webp' }, { name: 'Animoca Brands', img: '/anomica.png' }, { name: 'Pantera Capital', img: '/pantera.avif' },
  { name: 'a16z Crypto', img: '/a16z.jpeg' }, { name: 'Paradigm', img: '/paradigm.jpg' }, { name: 'Sequoia', img: '/sequoia.png' },
  { name: 'Binance Labs', img: '/binance.webp' }, { name: 'Multicoin', img: '/multicoin.png' }
];

export const stagePhotos = ['/1stage.jpg', '/2stage.jpg', '/3stage.jpg'];

export const roadmapData = [
  { phase: '2025 Q4', items: ['Launch Power Protocol & establish liquidity.', 'Release foundational token staking & infrastructure.', 'Demonstrate early utility.'] },
  { phase: '2026 Q1', items: ['Expand platform infrastructure via builder toolkits.', 'Establish cross-app identity & reward rails.', 'Demonstrate product growth.'] },
  { phase: '2026 Q2', items: ['Expand Power Labs & onboard new partners.', 'Develop AI-led adtech personalization.', 'Recycle value back into POWER.'] },
  { phase: '2026 Q3', items: ['Ecosystem growth via non-gaming apps.', 'Reach feature parity with liveops platforms.', 'Onboard mass market partners.'] }
];